// const baseUrl = "http://localhost:3000";
// const baseUrl = process.env.REACT_APP_REACT_APP_BASE_URL_DEV;
const baseUrl = process.env.NODE_ENV === 'development'? process.env.REACT_APP_REACT_APP_BASE_URL_DEV: process.env.REACT_APP_REACT_APP_BASE_URL;
const config = {
  graphqlBaseUrl: `${baseUrl}/graphql`,
  restBaseUrl: `${baseUrl}`,
  terms: `${window.location.origin}/Terms and conditions (EHC).pdf`
};

export default config;
